import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Card, Form, Badge, Modal, InputGroup } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { toUpperIfString } from 'utils/textFormat';
import CsLineIcons from 'cs-line-icons/CsLineIcons';
// Utils
import { handlerErrors } from 'utils/handleErrors';
import { ToastErrorCath, ToastSuccess } from 'components/alerts/toast';
// components
import ConnectionError from 'components/emptyStates/ConnectionError';
import EditBillingUserModal from 'components/modals/EditBillingUserModal';
import ClipLoader from 'react-spinners/ClipLoader';
import HtmlHead from '../../../components/html-head/HtmlHead';
import LoadingCar from '../../../components/loading/LoadingCar';
// API services
import { getBillingInfo, editBillingData } from '../../../api/Api-user';
import { useHandleResponse } from '../../../hooks/useHandleResponse';

const BillingUser = () => {
  const title = 'Facturación';
  const description = 'Facturación Plataforma Autopaquete';
  const { handleResponse } = useHandleResponse();
  const [billingInfo, setBillingInfo] = useState(() => {
    const stored = localStorage.getItem('billing');
    return stored ? JSON.parse(stored) : null;
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalToggleOpen, setIsModalToggleOpen] = useState(false);
  const [initialLoader, setInitialLoader] = useState(true);
  const [trigger, setTrigger] = useState(false);
  const [isEditDataLoader, setIsEditDataLoader] = useState(false);
  const [dataToUpdate, setDataToUpdate] = useState({});
  const [hasConnectionIssue, setHasConnectionIssue] = useState(false);

  const handlerGetProfile = async () => {
    try {
      const response = await getBillingInfo();
      // console.log('getProfile response', response);
      if (response.user_billing !== undefined) {
        setBillingInfo(response.user_billing);
        localStorage.setItem('billing', JSON.stringify(response.user_billing));
        setDataToUpdate({
          legalName: toUpperIfString(response.user_billing.legal_name),
          rfc: response.user_billing.tax_id,
          system: response.user_billing.tax_system,
          street: toUpperIfString(response.user_billing.street),
          streetNumber: response.user_billing.street_number,
          zip: response.user_billing.zip_code,
          neighborhood: toUpperIfString(response.user_billing.neighborhood),
          city: toUpperIfString(response.user_billing.city),
          state: toUpperIfString(response.user_billing.state),
          email: response.user_billing.billing_email,
          wantsInvoice: response.user_billing.wants_invoice,
        });
      }
    } catch (error) {
      handlerErrors(error);
      setHasConnectionIssue(true);
    } finally {
      setInitialLoader(false);
    }
  };
  const handlerEditUserBilling = async () => {
    // console.log('handlerEditUserBilling llamada');
    setIsEditDataLoader(true); // active loader in the button

    try {
      const response = await editBillingData(dataToUpdate);
      // console.log('response active/inactive or change email billing:', response);
      handleResponse(response, (res) => {
        if (res?.data.success !== undefined) {
          setTrigger((prev) => !prev);
          ToastSuccess(response?.data.message);
          setIsModalOpen(false); // CIERRA EL MODAL PARA EDITAR
          setIsModalToggleOpen(false); // CIERRA EL MODAL PARA ACTIVAR Y DESACTIVAR
        }
      });
    } catch (error) {
      handlerErrors(error);
    } finally {
      setIsEditDataLoader(false);
    }
  };
  useEffect(() => {
    handlerGetProfile();
  }, [trigger]);
  // useEffect(() => {
  //   console.log('dataToUpdate:', dataToUpdate);
  // }, [dataToUpdate]);
  return (
    <>
      {initialLoader && <LoadingCar />}
      <Modal show={isModalToggleOpen} onHide={() => setIsModalToggleOpen(false)}>
        <Modal.Header closeButton>
          {/* <Modal.Title className="text-primary">
            <div className="text-primary"> </div>{' '}
          </Modal.Title> */}
        </Modal.Header>
        <Modal.Body className="bg-infow">
          <div className="text-semi-large mb-4">
            ¿Confirmas que deseas <strong>desactivar</strong> la facturación?
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex flex-wrap justify-content-end bg-warningd">
            <Button variant="outline-primary" style={{ height: '36px' }} className="w-auto me-2 mb-2" onClick={() => setIsModalToggleOpen(false)}>
              Cancelar
            </Button>
            <Button
              variant="primary"
              size="xl"
              // className="mx-2"
              className="py-0"
              onClick={handlerEditUserBilling}
              style={{ height: '36px' }}
            >
              {isEditDataLoader && <ClipLoader disabled={isEditDataLoader} color="#FFFFFF" loading={isEditDataLoader} size={10} />}
              {isEditDataLoader ? 'Si, continuar' : 'Si, continuar'}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
      {isModalOpen && <EditBillingUserModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} data={billingInfo} setUpdatePage={setTrigger} />}
      {billingInfo === null && hasConnectionIssue && <ConnectionError refreshBtn />}
      {billingInfo && (
        <div id="pageContainer">
          <HtmlHead title={title} description={description} />
          <Row className="g-0 mb-3">
            {/* Title Start col-auto */}
            <Col xs="auto" className="col-auto mb-sm-0 me-auto">
              <NavLink className="muted-link pb-1 d-inline-block hidden breadcrumb-back" to="/">
                <CsLineIcons icon="chevron-left" size="13" />
                <span className="align-middle text-small ms-1">Inicio</span>
              </NavLink>
              <h1 className="mb-0 pb-0 display-4" id="title">
                {title}
              </h1>
            </Col>
            {/* Title End */}
          </Row>
          <Row>
            <Col xl="4">
              <h2 className=" small-title">Estado</h2>
              <Card className="mb-3">
                <Card.Body>
                  <div>
                    <Badge bg={`${billingInfo?.wants_invoice ? 'success' : 'muted'}`} className="text-uppercase fw-bolder" style={{ fontSize: '12px' }}>
                      {`${billingInfo?.wants_invoice ? 'Activa' : 'Inactiva'}`}
                    </Badge>
                    <div className="bg-warningx d-flex my-3">
                      <span className="me-1 d-flex aling-items-end bg-infox">
                        {`${billingInfo?.wants_invoice ? 'Desactivar facturación' : 'Activar facturación'}`}
                      </span>
                      <Form.Check // prettier-ignore
                        type="switch"
                        //  id="switch_insurance"
                        className="bg-successx d-flex aling-items-end"
                        checked={billingInfo?.wants_invoice}
                        onChange={() => {
                          setDataToUpdate({ ...dataToUpdate, wantsInvoice: !billingInfo.wants_invoice });
                          if (billingInfo?.wants_invoice) {
                            setIsModalToggleOpen(true); // abre el modal para desactivar
                          } else {
                            setIsModalOpen(true); // abre el  modal para editar o creae
                          }
                        }}
                      />
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </Col>
            <Col xl="8">
              {billingInfo?.wants_invoice ? (
                <>
                  <h2 className="small-title">Información Fiscal</h2>
                  <Card className="mb-5 position-relative">
                    <Card.Body>
                      <Row className="g-0">
                        {/* lg="7" xl="12" */}
                        <Col xs="12" className="bg-successx d-flex flex-column justify-content-start">
                          <div className="text-alternate mb-2">
                            <div className="text-alternate">{billingInfo?.legal_name}</div>
                          </div>
                          <div className="text-alternate mb-2">{`RFC. ${billingInfo?.tax_id}`}</div>
                          <div className="text-alternate mb-2">{`${billingInfo?.tax_system} | ${billingInfo?.tax_system_value}`}</div>
                        </Col>
                        <Col xs="12" className="bg-warningx mb-5 d-flex flex-column justify-content-start">
                          {billingInfo?.street && (
                            <div className="text-alternate mb-2">
                              <span>{`${billingInfo?.street} # ${billingInfo?.street_number}`}</span>
                            </div>
                          )}
                          {billingInfo?.zip_code && (
                            <div className="text-alternate mb-2">
                              <span> {`${billingInfo?.neighborhood} C.P. ${billingInfo?.zip_code}`}</span>
                            </div>
                          )}
                          {billingInfo?.city && (
                            <div className="text-alternate mb-2">
                              <span> {`${billingInfo?.city}, ${billingInfo?.state}.`}</span>
                            </div>
                          )}
                          <div className="text-alternate mb-2">
                            {billingInfo?.billing_email}
                            <em className="d-block text-small">Correo para envío de facturas</em>
                          </div>
                        </Col>
                        <div className="d-flex justify-content-end align-items-end me-5" style={{ position: 'absolute', bottom: '20px', right: '0px' }}>
                          <Button
                            variant="primary"
                            className="btn-icon btn-icon-start w-auto "
                            onClick={() => {
                              setIsModalOpen(true);
                            }}
                          >
                            <CsLineIcons icon="edit" size="18" />
                            <span> Editar </span>
                          </Button>
                        </div>
                      </Row>
                    </Card.Body>
                  </Card>
                </>
              ) : (
                <>
                  <h2 className="invisible small-title">Recibos</h2>
                  <Card className="mb-5">
                    <Card.Body>
                      <Row className="g-0">
                        {/* lg="7" xl="12" */}
                        <Col xs="12" className="bg-successx d-flex flex-column justify-content-start">
                          <Form.Label>
                            Si no tienes activa la facturación, te enviaremos un recibo por cada depósito que realices. Puedes actualizar aquí el correo
                            electrónico donde deseas recibirlos. También puedes consultar todos tus recibos en el apartado{' '}
                            <NavLink to="/finanzas/comprobantes" className="text-primary text-decoration-underline">
                              Finanzas &gt; Comprobantes
                            </NavLink>
                            .
                          </Form.Label>
                          <InputGroup>
                            <InputGroup.Text>
                              <CsLineIcons icon="email" size="16" className="text-alternate" />
                            </InputGroup.Text>
                            <Form.Control
                              required
                              type="email"
                              placeholder="correo"
                              value={dataToUpdate.email}
                              onChange={(e) => {
                                setDataToUpdate({ ...dataToUpdate, email: e.target.value });
                              }}
                            />
                          </InputGroup>
                        </Col>
                        <div className="d-flex justify-content-end align-items-end mt-3">
                          <Button
                            variant="primary"
                            className="btn-icon btn-icon-start w-auto"
                            disabled={isEditDataLoader}
                            onClick={() => {
                              if (!dataToUpdate.email) {
                                ToastErrorCath('Ingresa un correo electrónico para continuar');
                              } else {
                                handlerEditUserBilling();
                              }
                            }}
                          >
                            {isEditDataLoader && <ClipLoader color="#FFFFFF" loading={isEditDataLoader} size={10} />}
                            {isEditDataLoader ? 'Guardar' : 'Guardar'}
                          </Button>
                        </div>
                      </Row>
                    </Card.Body>
                  </Card>
                </>
              )}
            </Col>
          </Row>
        </div>
      )}
    </>
  );
};

export default BillingUser;
